import { createAsyncThunk } from '@reduxjs/toolkit';
import apiCall from 'utils/api';
import { IPlanData, ISummaryCards, IShiftRequests, IWeeklyActivity } from './types';

export const fetchOrgSummary = createAsyncThunk(
  'orgDashboard/fetchSummary',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ data: ISummaryCards }>('get', '/api/organization/dashboard/summary/');
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch summary');
    }
  }
);

export const fetchOrgShiftRequests = createAsyncThunk(
  'orgDashboard/fetchShiftRequests',
  async (period: string = 'This Week', { rejectWithValue }) => {
    try {
      const response = await apiCall<{ data: IShiftRequests }>('get', `/api/organization/dashboard/shift-requests/?period=${period}`);
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch shift requests');
    }
  }
);

export const fetchOrgWeeklyActivity = createAsyncThunk(
  'orgDashboard/fetchWeeklyActivity',
  async (params: { start_date?: string; end_date?: string } | undefined, { rejectWithValue }) => {
    try {
      const query = params ? `?start_date=${params.start_date}&end_date=${params.end_date}` : '';
      const response = await apiCall<{ data: IWeeklyActivity[] }>(
        'get',
        `/api/organization/dashboard/weekly-activity/${query}`,
      );
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch weekly activity');
    }
  },
);

export const fetchOrgPlan = createAsyncThunk(
  'orgDashboard/fetchPlan',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ data: IPlanData }>('get', '/api/organization/dashboard/plan/');
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch plan data');
    }
  }
);
